import { getRelationsKeysForMatching } from "helpers/expandHelpers/getRelationsKeysForMatching";
import { getItemClassFromItemId } from "helpers/getItemClassFromItemId";

import { useGetTaxonomyItemByClassAndIdWithCache } from "api/useGetTaxonomyItemByClassAndId";

export const useMatchedTaxonomyItem = (itemID = "") => {
  const relationsKeysToExpand = itemID ? getRelationsKeysForMatching(getItemClassFromItemId(itemID)[0]) : [];
  return useGetTaxonomyItemByClassAndIdWithCache(itemID, relationsKeysToExpand);
}
